import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import ParagraphWithVideo from "template-store/components/paragraph-with-video/paragraph-with-video";
import ParagraphWithDemoComponent from "template-store/components/paragraph-with-demo/paragraph-with-demo-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getSolutionCategoryIds } from "template-store/services/solution-data-service";
import { getCloudinartDemoVideoURLForCategory } from "template-store/services/solution-categories-service";
import { StyledTemplateFeatureContent } from "./template-feature-content.scss";
import BulbIcon from "static/svg/templates-store//bulb.svg";
const TemplateFeatureContent = (props)=>{
    const { templateData, translate, featureTitleKey, featureDescriptionKey, subsectionTitleKey, subsectionDescriptionKey, demoComponent, demoComponentMetadata, templateDataFieldName, demoVideoFileName } = props;
    const videoSrc = useMemo(()=>{
        const firstCategory = getSolutionCategoryIds(templateData)[0];
        return getCloudinartDemoVideoURLForCategory(firstCategory, demoVideoFileName);
    }, [
        demoVideoFileName,
        templateData
    ]);
    return /*#__PURE__*/ _jsx(StyledTemplateFeatureContent, {
        className: "template-feature-content",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "paragraph-with-image-wrapper",
            children: [
                /*#__PURE__*/ _jsx(ParagraphWithVideo, {
                    title: translate(featureTitleKey),
                    description: translate(featureDescriptionKey),
                    videoSrc: videoSrc
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "demo-component-wrapper",
                    children: /*#__PURE__*/ _jsx(ParagraphWithDemoComponent, {
                        title: translate(subsectionTitleKey),
                        description: translate(subsectionDescriptionKey),
                        templateData: templateData,
                        icon: BulbIcon,
                        demoComponent: demoComponent,
                        demoComponentMetadata: demoComponentMetadata,
                        templateDataFieldName: templateDataFieldName
                    })
                })
            ]
        })
    });
};
export default withGenericConfig(TemplateFeatureContent);
